import { createTheme } from '@mui/material/styles';
import { luxPalette } from 'styles/luxPalette';

import { luxTypography } from './Lux/typography';
import { luxSemantics } from './styles/luxPalette';

// A custom theme for this app
export const FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, “Segoe UI”, Roboto, Helvetica, Arial, sans-serif, “Apple Color Emoji”, “Segoe UI Emoji”, “Segoe UI Symbol”';
export const MONO_FONT_FAMILY = 'Menlo, Consolas, "Ubuntu Mono", "Roboto Mono", "DejaVu Sans Mono", monospace;';

export const themeConfig = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1440,
    },
  },
  typography: {
    fontFamily: FONT_FAMILY,
    body1: { ...luxTypography.body },
    ...luxTypography,
  },
  palette: {
    primary: {
      light: luxPalette.primary[2],
      main: luxPalette.primary[5],
      dark: luxPalette.primary[7],
      contrastText: '#fff',
    },
    secondary: {
      light: luxPalette.primary[0.5],
      main: luxPalette.primary[1],
      dark: luxPalette.primary[2],
      contrastText: luxPalette.primary[5],
    },
    tertiary: {
      light: luxPalette.neutral[5],
      main: luxPalette.neutral[8],
      dark: luxPalette.neutral[10],
      contrastText: '#fff',
    },
    midnight: {
      light: luxPalette.neutral[10],
      main: luxPalette.primary[10],
      dark: luxPalette.primary[12],
      contrastText: '#fff',
    },
    info: {
      light: luxPalette.info[1],
      main: luxPalette.info[5],
      dark: luxPalette.info[10],
      contrastText: '#fff',
    },
    error: {
      light: luxPalette.alert[1],
      main: luxPalette.alert[5],
      dark: luxPalette.alert[10],
    },
    warning: {
      light: luxPalette.caution[1],
      main: luxPalette.caution[5],
      dark: luxPalette.caution[10],
    },
    success: {
      light: luxPalette.success[1],
      main: luxPalette.success[5],
      dark: luxPalette.success[10],
    },
    background: {
      default: '#fff',
    },
    lux: luxPalette,
    luxSemantics,
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: 500,
          textTransform: 'none' as const,
          whiteSpace: 'nowrap' as const,
          borderRadius: '4px',
        },
        sizeSmall: {
          height: '28px',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          fontSize: '16px',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        color: 'primary',
      },
    },
  },
};

const theme = createTheme(themeConfig);
export type ClariumTheme = typeof theme;
export default theme;
